import { useTranslation } from '@/i18n';
import type { ColumnType } from 'antd/es/table/interface';
import { useMemo } from 'react';
import { AmountCell } from './Cells/AmountCell';
import amountStyles from './Cells/AmountCell.module.scss';
import type { PaymentRequestRow } from './hooks';

export type UseColumnsProps = {
  isAmountColumnEnabled: boolean;
};

export const useColumns = ({
  isAmountColumnEnabled,
}: UseColumnsProps): ColumnType<PaymentRequestRow>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    const baseColumns: ColumnType<PaymentRequestRow>[] = [
      {
        dataIndex: 'numberWithoutPrefix',
        title: t('payment_past_details_number_without_prefix'),
        width: 66,
      },
      {
        dataIndex: 'title',
        title: t('payment_past_details_title'),
        width: 280,
      },
      {
        dataIndex: 'payee',
        title: t('payment_past_details_payee'),
        width: 182,
      },
      {
        dataIndex: 'createdAt',
        title: t('payment_past_details_uploaded_at'),
        width: 100,
      },
    ];

    if (!isAmountColumnEnabled) return baseColumns;

    const amountColumn: ColumnType<PaymentRequestRow> = {
      dataIndex: 'totalAmount',
      title: t('payment_past_details_total_amount'),
      width: `${amountStyles['column_total_amount_width']}px`,
      align: 'right',
      render: (_, row) => (
        <AmountCell
          totalAmount={row.totalAmount}
          foreignCurrencyAmount={row.foreignCurrencyAmount}
        />
      ),
    };

    // Insert after `payee` (index 2), before `createdAt`.
    return [...baseColumns.slice(0, 3), amountColumn, ...baseColumns.slice(3)];
  }, [t, isAmountColumnEnabled]);
};
